'use client';
import { useContext } from 'react';

function useNonNullishContext(t) {
    let e = useContext(t);
    if (null == e) throw Error(`Context:${t.displayName} is null Or undefined`);
    return e;
}

export { useNonNullishContext };
